import { QueryClient } from '@tanstack/react-query';
import {
  GeneralSuggestedAction,
  GeneralSuggestedActionType,
} from 'models/SuggestedActions';
import { ENTERPRISE_SUGGESTED_ACTIONS_QUERY_KEY } from './hooks/useEnterpriseSuggestedActionsQuery';
import { GENERAL_SUGGESTED_ACTIONS_QUERY_KEY } from './hooks/useGeneralSuggestedActionsQuery';

export const refetchEnterpriseSuggestedActions = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({
    queryKey: [ENTERPRISE_SUGGESTED_ACTIONS_QUERY_KEY],
  });

export const refetchGeneralSuggestedActions = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({
    queryKey: [GENERAL_SUGGESTED_ACTIONS_QUERY_KEY],
  });

export const removeGeneralSuggestedAction = (
  queryClient: QueryClient,
  type: GeneralSuggestedActionType,
) => {
  queryClient.setQueriesData<GeneralSuggestedAction[]>(
    { queryKey: [GENERAL_SUGGESTED_ACTIONS_QUERY_KEY] },
    (oldData) =>
      oldData ? oldData.filter((item) => item.type !== type) : oldData,
  );

  queryClient.invalidateQueries({
    queryKey: [GENERAL_SUGGESTED_ACTIONS_QUERY_KEY],
  });
};
